var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5544 2.28369H10.4934C10.6927 2.28369 10.8002 2.47231 10.8002 2.69665V12.1919C10.8002 12.4163 10.6927 12.6006 10.4934 12.6006H1.61614C1.41687 12.6006 1.2002 12.4177 1.2002 12.1919V2.69665C1.2002 2.47231 1.41529 2.28369 1.61614 2.28369H3.44599",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07605 5.64111H2.92383",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07605 7.89844H2.92383",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05529 10.1562H2.92383",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15172 1.3999H3.89577C3.6617 1.3999 3.46875 1.5728 3.46875 1.78571V2.81026C3.46875 3.02174 3.6617 3.19607 3.89577 3.19607H8.15172C8.38737 3.19607 8.57873 3.02174 8.57873 2.81026V1.78571C8.57873 1.57423 8.38737 1.3999 8.15172 1.3999Z",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.dc10f862f3a92c44ebc01cb19859e29f.svg";
export { ForwardRef as ReactComponent };